var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 325,
    viewBox: "0 0 344 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.498 157.532L266.572 157.469L266.641 157.4C272.889 151.152 272.889 141.021 266.641 134.773C260.426 128.559 250.372 128.525 244.116 134.671L188.413 179.208V20C188.413 11.1634 181.25 4 172.413 4C163.577 4 156.413 11.1634 156.413 20V179.208L100.711 134.671C94.4548 128.525 84.4006 128.559 78.1863 134.773C71.9379 141.021 71.9379 151.152 78.1863 157.4L78.2551 157.469L78.3291 157.532L161.172 228.385C167.402 234.538 177.425 234.538 183.655 228.385L266.498 157.532Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 228.312C33.5 220.028 26.7843 213.312 18.5 213.312C10.2157 213.312 3.5 220.028 3.5 228.312V286.25C3.5 305.58 19.17 321.25 38.5 321.25H320.5C331.546 321.25 340.5 312.296 340.5 301.25V228.312C340.5 220.028 333.784 213.312 325.5 213.312C317.216 213.312 310.5 220.028 310.5 228.312V291.25H38.5C35.7386 291.25 33.5 289.012 33.5 286.25V228.312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDl);
export default __webpack_public_path__ + "static/media/icon-dl.99a082dcc51e7b30b2db3955afe1c289.svg";
export { ForwardRef as ReactComponent };